import React, { useCallback } from 'react';
import { InfoList } from '@core/js/components/common/InfoList';
import { withComponent } from '@core/js/components/hocs/withComponent';
import { CookieSettingsToggle } from './components/CookieSettingsToggle';

import * as Types from './../../types';

import style from './CookieSettings.scss';

export const CookieSettingsBare: React.FC<Types.ICookieSettingsProps> = ({
    data,
    setData
}) => {
    const onToggleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>): void => {
        const { checked, name } = event.target;
        setData({ ...data, [name]: checked });
    }, [data, setData]);

    return (
        <div className={style.container}>
            <InfoList className={style.list} classNames={{ item: style.infoListItem }}>
                <CookieSettingsToggle
                    cookieKey="system"
                    data={data}
                    isSystem={true}
                />
                {Object.keys(data).map(cookieKey => (
                    <CookieSettingsToggle
                        key={cookieKey}
                        cookieKey={cookieKey}
                        data={data}
                        onToggleChange={onToggleChange}
                    />
                ))}
            </InfoList>
        </div>
    );
};

export const CookieSettings = withComponent({
    tkPrefix: 'playtech.mobile.system.cookie-settings-popup.'
})(CookieSettingsBare);
